/* eslint semi:0 */
import 'isomorphic-fetch'
import { warn } from '../application/console'
import { registerUtils } from '../application/nm'
import { create as makeEmptyObj } from './object'

function json(response) {
  if (!response) {
    return Promise.reject(response)
  }
  return response.json()
}

function handleResponseCode(response) {
  return response.ok ? response : Promise.reject(response)
}

function handleFetchError(url, conf, response) {
  const { status, statusText } = response // eslint-disable-line no-shadow
  const errorMessage = `Failed fetching url '${url}'!
  Status ${status}, statusText '${statusText}'.`
  warn(errorMessage, { url, conf, status, statusText, response })
  return Error(errorMessage)
}

export function getResponseText(url, conf = {}) {
  return fetch(url, conf).then(handleResponseCode).catch(handleFetchError.bind(null, url, conf))
}
export function getJsonOrError(url, conf = {}) {
  return getResponseText(url, conf).then(json)
}

const fetchUtils = Object.assign(makeEmptyObj(), {
  getResponseText,
  getJsonOrError,
})

registerUtils({ fetchUtils })



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/utils/fetch.js